/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { toast } from "react-hot-toast";
import { GET_VERIFY_CRED } from "../pages/VerifierView/graphql/get-verify-credential.query";

const SERVICE_NAME = "analytics.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class VerifierService {
    name = SERVICE_NAME;
    private static instance: VerifierService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new VerifierService();
        }
        return this.instance;
    }

    async getVerifyCredentials(payload: string) {
        log.blue(`in service :`, payload)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_VERIFY_CRED,
                    variables: {
                        tag: payload
                    },
                    fetchPolicy: "network-only",
                });
                return res?.data?.verifyCredential;
            }
        } catch (err: any) {
            toast.error("Error in validating the blockchain proof point")
            // err?.graphQLErrors &&
            //     Array.isArray(err?.graphQLErrors) &&
            //     err?.graphQLErrors.length > 0 &&
            //     toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, 'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
